module.exports = __webpack_public_path__ + "img/mananjemen_aset.9a6b446b.svg";